import { withApiActions } from './apiActionHelper';

export function getPreviewTrackingData(shopId, language) {
  return withApiActions(
    (api) => api.getPreviewTrackingData(shopId, language),
    'PREVIEW_TRACKING'
  );
}
